export class FakeLocalStorage implements Storage {
    public length: number;

    private data: Record<string, string | null>;

    constructor() {
        this.data = {};
        this.length = 0;
    }

    // eslint-disable-next-line class-methods-use-this
    public clear(): void {
        throw new Error("Method not implemented.");
    }

    // eslint-disable-next-line class-methods-use-this
    public key(): string | null {
        throw new Error("Method not implemented.");
    }

    public getItem(key: string) {
        return this.data[key];
    }

    public setItem(key: string, value: string | null) {
        this.data[key] = value;
    }

    public removeItem(key: string) {
        delete this.data[key];
    }
}
